<template>
  <div>
    <lk-modal v-model="status"
    :footer-hide='true'
    :title="title"
    width="400"
    >
    <div class="container">
      <div class="subTitle">
        <span
            :class="{
                'iconfont':true,
                'alert':true,
            }">&#xe613;
        </span>
        <span class="word">{{subTitle}}</span>
      </div>
      <div class="content">
        <span class="contentList" v-for="item in list" :key="item">
            {{item}}
        </span>
      </div>
      <div class="btns">
        <lk-button @click="cancel" v-if="!noCancel" class="cancel">{{cancelText}}</lk-button>
        <lk-button type='primary' @click="confirm" :loading='confirmLoading'>{{confirmText}}</lk-button>
      </div>
    </div>
    </lk-modal>
  </div>
</template>
<script>
export default {
  name: 'dtpModal',
  props: {
    confirmLoading: {
      type: Boolean,
      default: false,
    },
    noCancel: {
      type: Boolean,
      default: false,
    },
    status: {
      type: Boolean,
      // default: true,
    },
    content: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'info',
    },
    confirmText: {
      type: String,
      default: '确定',
    },
    cancelText: {
      type: String,
      default: '取消',
    },
    title: {
      type: String,
      default: '提示',
    },
    subTitle: {
      type: String,
      default: '提示',
    },
    list: {
      default: ['提示文案'],
    },
  },
  model: {
    prop: 'status',
    event: 'click',
  },
  data() {
    return {};
  },
  methods: {
    cancel() { // 实现model绑定
      this.$emit('click', false);
      this.$nextTick(() => {
        this.$emit('handleCancel');
      });
      // this.status = false;
    },
    confirm() {
      this.$emit('confirm', true);
    },
  },
  created() {
    // console.log(this.value);
  },
};
</script>
<style lang="less" scoped>
.container{
//   height: 136px;
  position: relative;
  .btns{
    display: flex;
    justify-content: flex-end;
    position: absolute;
    bottom: 0;
    right: 0;
    width: 136px;
  .cancel{
    margin-right: 16px
  }
  }
.title {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  .word{
    font-size: 14px;
    color: rgba(0,0,0,0.75);
    margin-left: 8px
  }
}
.subTitle{
  display: flex;
  align-items: left;
  .icon{
    margin-right: 16px;
    color: #1890FF
  }
  .alert{
    color: orange;
  }
  .info{
    color: #1890FF
    // color: #FF4D07
  }
  .word{
    font-size: 14px;
    color: rgba(0,0,0,0.75);
    margin-left: 8px
  }
}
  .content{
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    padding: 0 0 0 10px;
    width: 100%;
    max-height: 300px;
    overflow: auto;
    border-bottom: 50px solid white;
  }
  .line {
    height: 1px;
    background-color: black;
  }
  .contentList {
    padding-left: 15px;
    flex-wrap: wrap;
  }
}
</style>